module.exports = __webpack_public_path__ + "static/media/GoogleLogo.e5abadc0.png";